import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgTablet(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="10 7 39 45"
      fill="none"
      {...props}
    >
      <path
        fill={props.primaryColor}
        stroke="#fff"
        strokeWidth={0.3}
        d="M12.567 45.23v-31.7c0-2.263 2.248-4.173 5.037-4.173h24.209c2.788 0 5.037 1.91 5.037 4.173v31.7c0 2.264-2.249 4.174-5.037 4.174h-24.21c-2.788 0-5.036-1.91-5.036-4.173Zm3.158 0c0 .908.863 1.592 1.879 1.592h24.209c1.015 0 1.879-.684 1.879-1.591V13.53c0-.907-.864-1.591-1.88-1.591H17.605c-1.016 0-1.88.684-1.88 1.59z"
      />
      <circle cx={29.708} cy={42.83} r={1.921} fill={props.secondaryColor} />
    </svg>
  );
}
export default SvgTablet;
